import * as types from './types';
import * as logsActions from 'services/api/logs';
import { uiActions } from 'state/modules/UI';

import { getErrorMessage, parsePagination } from 'utils';

const fetchLogsRequest = () => ({
  type: types.FETCH_LOGS_REQUEST,
});

const fetchLogsSuccess = (payload) => ({
  type: types.FETCH_LOGS_SUCCESS,
  payload,
});

const fetchLogsFailed = (error) => ({
  type: types.FETCH_LOGS_FAILED,
  error,
});

export const fetchLogs = (params) => {
  return async (dispatch) => {
    dispatch(fetchLogsRequest());

    const response = await logsActions.fetchLogs(params);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchLogsSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchLogsFailed(error));
  };
};
